<template>
  <div class="market-switcher-modal critical-component-hide">
    <div class="market-switcher-modal__header">
      <p
        class="text-heading-l"
        v-text="strings.title"
      />

      <p
        class="text-body-s"
        v-text="strings.text"
      />
    </div>

    <div class="market-switcher-modal__buttons">
      <btn
        :label="strings.suggestedCta"
        type="button"
        @click="handleSuggestedStoreClick"
      />

      <btn
        class="market-switcher-modal__continue"
        :label="strings.continueCta"
        modifiers="text"
        :show-icon="false"
        type="button"
        @click="handleContinueClick"
      />
    </div>

    <input
      v-if="isActive"
      name="country_code"
      type="hidden"
      :value="suggestedCountry.code"
    >
  </div>
</template>

<script>

/**
 * Vue: Market switcher modal (market-switcher-modal)
 * -----------------------------------------------------------------------------
 * Modal prompt when current store doesn't match preferences.
 *
 * @param {HTMLElement} form - Localization form.
 * @param {Boolean} isActive - Overlay is active.
 *
 */
import { mapActions, mapState } from 'vuex'

import Btn from '~global/btn/btn'

export default {
  name: 'MarketSwitcherModal',

  components: {
    Btn,
  },

  props: {
    form: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: true,
      required: true,
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      currentCountry: (state) => state['market-switcher'].currentCountry,
      suggestedCountry: (state) => state['market-switcher'].suggestedCountry,
    }),

    /**
     * Compute strings.
     * @returns {Object}
     */
    strings() {
      const settings = {
        replace: {
          current_country: this.currentCountry?.name,
          suggested_country: this.suggestedCountry?.name,
        },
      }

      return {
        continueCta: this.$string('market_switcher.modal.continue_cta', settings),
        suggestedCta: this.$string('market_switcher.modal.suggested_cta', settings),
        text: this.$string('market_switcher.modal.text', settings),
        title: this.$string('market_switcher.modal.title', settings),
      }
    },
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      closeOverlay: 'overlays/close',
      setPreference: 'market-switcher/setPreference',
    }),

    /**
     * Handle continue click.
     * - Set preference and close modal.
     */
    handleContinueClick() {
      this.setPreference(this.currentCountry)
      this.closeOverlay('marketSwitcherModal')
    },

    /**
     * Handle suggested store click.
     * - Set preference and submit localization form.
     */
    handleSuggestedStoreClick() {
      this.setPreference(this.suggestedCountry)

      if (!this.form) {
        return
      }

      if(this.suggestedCountry.url && this.form instanceof HTMLFormElement) {
        this.form.setAttribute('action', `${this.suggestedCountry.url}/localization`)
      }

      this.form.submit()
    },
  },
}
</script>

<style lang="scss">
@import './market-switcher-modal';
</style>
